export class Lifestyle {
  lifestyle = [];
  completed = false;
  constructor() {
    this.lifestyle = this._initLifestyle();
  }

  private _initLifestyle() {
    return [
      {
        key: 'health',
        text: 'My Health',
        displayData: false,
        iconColor: 'white',
        questionRaws: [
          {
            key: 'iSmoke',
            label: 'I smoke',
            order: 1,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Never', color: 'blue' },
                { content: 'A lot', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'FINANCE_SPECIAL_PROJECT_TIME_TYPE'
            },
            value: 0
          },
          {
            key: 'iDrink',
            label: 'I drink',
            order: 2,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Never', color: 'blue' },
                { content: 'A lot', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'DRINK_TYPE'
            },
            value: 50
          },
          {
            key: 'iEatHealthy',
            label: 'I eat healthy',
            order: 3,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Never', color: 'blue' },
                { content: 'Always', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'EAT_HEALTHY_TYPE'
            },
            value: 50
          },
          {
            key: 'lifestyleIndex',
            label: 'Lifestyle Index',
            order: 4,
            required: false,
            controlType: 'gauge-chart',
            options: {
              labels: [
                'Inspiring',
                'Keep up',
                'Border line',
                'Watch out',
                'Be concerned',
                'Change!'
              ]
            },
            value: -12,
            icon: 'data:image/svg+xml;base64,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'
          },
          {
            key: 'myHeight',
            label: 'My height',
            order: 5,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 120, max: 200 },
              labels: [
                { content: '165cm', color: 'black' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'HEIGHT_TYPE'
            },
            value: 120
          },
          {
            key: 'myWeight',
            label: 'My weight',
            order: 6,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 30, max: 150 },
              labels: [
                { content: '50kg', color: 'black' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'WEIGHT_TYPE'
            },
            value: 30
          },
          {
            key: 'bodyMassIndex',
            label: 'Body Mass Index',
            order: 7,
            required: false,
            controlType: 'gauge-chart',
            options: {
              labels: [
                'Watch out',
                'Keep up',
                'Border line',
                'Watch out',
                'Be concerned',
                'Change!'
              ]
            },
            value: -80,
            icon: 'data:image/svg+xml;base64,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'
          },
          {
            key: 'getSick',
            label: 'How often I get sick',
            order: 8,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Never', color: 'blue' },
                { content: 'Often', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'GET_SICK_TYPE'
            },
            value: 50
          },
          {
            key: 'medicalCheckUp',
            label: 'Frequency of medical check up',
            order: 9,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Never', color: 'blue' },
                { content: 'Yearly', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: true,
              showTrack: true,
              type: 'MEDICAL_CHECK_UP_TYPE'
            },
            value: 50
          },
          {
            key: 'familyCriticalIllness',
            label: 'My parents/siblings had any critical illnesses',
            order: 10,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'No', color: 'blue' },
                { content: 'Yes', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: true,
              showTrack: true,
              type: 'FAMILY_MEMBER_HAD_ILLNESS_TYPE'
            },
            value: 50
          },
          {
            key: 'myCriticalIllness',
            label: 'I am concerned about having a critical illness',
            order: 11,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Not concerned', color: 'blue' },
                { content: 'Very concerned', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'HAVING_A_CRITICAL_ILLNESS_TYPE'
            },
            value: 50
          },
          {
            key: 'disease',
            label: 'I feel well protected if I have a disease',
            order: 12,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Yes', color: 'blue' },
                { content: 'No', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'FELL_WELL_PROTECTED_IF_HAVING_A_DISEASE_TYPE'
            },
            value: 50
          },
          {
            key: 'accident',
            label: 'I feel well protected if I have an accident',
            order: 13,
            required: false,
            controlType: 'slider',
            options: {
              range: { min: 0, max: 100 },
              labels: [
                { content: 'Yes', color: 'blue' },
                { content: 'No', color: 'red' }
              ],
              step: 1,
              showLabels: true,
              showTicks: false,
              showTrack: true,
              type: 'FELL_WELL_PROTECTED_IF_HAVING_AN_ACCIDENT_TYPE'
            },
            value: 50
          },
        ]
      }];
  }

}



// WEBPACK FOOTER //
// ./src/app/core/models/lifestyle.ts